// extracted by mini-css-extract-plugin
module.exports = {"news-item-box":"ag","newsItemBox":"ag","img-box":"ah","imgBox":"ah","img-mask-box":"ai","imgMaskBox":"ai"};